import React from 'react'
import { CrossClientQueryResultCellProps } from './types'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientClients, selectCrossClientClientsLoading } from '../../../../store/crossClient/crossClientResults'
import { UserAvatar } from '../../../../components/UserAvatar/UserAvatar'
import { getUserDisplayName } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { getInitials } from '../../../utils'

export const CrossClientQueryResultClientCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const clients = useAppSelector(selectCrossClientClients)
  const clientsLoading = useAppSelector(selectCrossClientClientsLoading)

  if (!clients[result.clientId] && clientsLoading) {
    return <div className='skeleton pt-2 zocks-border-0.5' style={{ width: '30%', height: '30px' }} />
  }

  const client = clients[result.clientId]
  const name = getUserDisplayName(client)
  const initials = getInitials(name)

  return (
    <div className='d-flex zocks-py-0.75 gap-3 align-items-center'>
      <UserAvatar useInitials initialLetters={initials} className='cross-client-client-avatar' />
      <div className='d-flex flex-column'>
        <div className='paragraph-medium'>{name}</div>
        <div className='paragraph-small zocks-text-gray-600'>{client?.email ?? ''}</div>
      </div>
    </div>
  )
}
